import * as React from 'react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl, FormHelperText, InputLabel } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';

import BaseSelectWithCheckboxes from '../../../../../../shared/components/base-select-with-checkboxes/base-select-with-checkboxes';
import { mapPlatformModelToItemLabelModel } from '../../../../../shared/utils/mapping/mapping.utils';
import withApkPlatformsOptions from './components/with-apk-platforms-options/with-apk-platforms-options';
import { ApkPlatformsDropdownProps } from './types/apk-platforms-dropdown-props.type';

const ApkPlatformsDropdown: FunctionComponent<ApkPlatformsDropdownProps> = (
  props: PropsWithChildren<ApkPlatformsDropdownProps>
) => {
  const { setFieldValue, options, values, handleBlur, errors, touched } = props;

  return (
    <FormControl
      classes={{
        root: 'form-control-main',
      }}
      key="apks-platforms"
      variant="filled"
      error={touched.platforms && !!errors.platforms}
    >
      <InputLabel id="multiple-checkbox-label-platforms" required>
        Platforms
      </InputLabel>

      <BaseSelectWithCheckboxes
        id="platforms"
        name="platforms"
        onChange={(event: SelectChangeEvent<number[]>) => {
          const val = event.target.value;
          setFieldValue('platforms', val);
        }}
        onBlur={handleBlur}
        selectOptions={options.map(mapPlatformModelToItemLabelModel)}
        value={
          values.platforms && values.platforms.length ? values.platforms : []
        }
      />
      {touched.platforms && errors.platforms && (
        <FormHelperText>{errors.platforms}</FormHelperText>
      )}
    </FormControl>
  );
};

export default withApkPlatformsOptions(ApkPlatformsDropdown);
